export default {
	props:{
		prevLink: String,
		prevLinkActive: Boolean,
		prevLinkClass:{
			type:String,
			default:'prev outline',
		},
		prevLinkText:{
			type:String,
			default:'buttons.back',
		},
		nextLink: String,
		nextLinkActive: Boolean,
		nextLinkClass:{
			type:String,
			default:'next fill',
		},
		nextLinkText:{
			type:String,
			default:'buttons.continue',
		},
	},
	data(){
		return {}
	},
	watch: {
		//
	},
	methods: {
		//
	},
	template: `
<div class="row__separator">
	<a :class="['button', prevLinkClass]" :href="prevLink" target="_self" v-if="prevLinkActive" @click="$emit('click-prev', $event)">
		<span v-t="prevLinkText"></span>
	</a>
	<a :class="['button', nextLinkClass]" :href="nextLink" target="_self" v-if="nextLinkActive" @click="$emit('click-next', $event)">
		<span v-t="nextLinkText"></span>
	</a>
</div>
`,
}
